import { connect } from 'react-redux';
import { getAppCrashErrorMessage, isApplicationCrashed } from 'state/appCrashed';
import { appCrashedSendHelpRequestThunk } from 'state/appCrashed/appCrash.thunks';
import type { ThunkDispatch } from 'state/state.common';
import type { AppState } from 'state/state.model';

interface StateProps {
  isCrashed: boolean;
  errorMessage: string | null;
}

interface OwnProps {
  isDeveloperMode: boolean;
}

interface DispatchProps {
  sendManualMail: (errorMessage: string, userComment: string) => void;
}

export type AppCrashedProps = OwnProps & StateProps & DispatchProps;

const mapStateToProps = (state: AppState): StateProps => {
  const isCrashed = isApplicationCrashed(state);
  const errorMessage = getAppCrashErrorMessage(state);
  return {
    isCrashed,
    errorMessage,
  };
};

const mapDispatchToProps = (dispatch: ThunkDispatch, _ownProps: OwnProps): DispatchProps => ({
  sendManualMail(errorMessage: string, userComment: string) {
    dispatch(appCrashedSendHelpRequestThunk(errorMessage, userComment, false));
  },
});

export const connectAppCrashed = connect(mapStateToProps, mapDispatchToProps);
